import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ButtonLoading from "../../../UI/Button/ButtonLoading";
import Alert from "../../../UI/Alert/Alert";
import { NotifyContext } from "../../../context/notifyContext";
import UserAPI from "../../../services/api/UserService";
import { Tutor } from "../../../Types/Users";

interface DeleteTutorProps {
    onClose?: () => void;
    tutor?: Tutor | null;
}

export default function DeleteTutor(props: DeleteTutorProps) {
    const { tutor } = props;

    const notify = useContext(NotifyContext);
    const navigate = useNavigate();

    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const handleDelete = () => {
        setLoading(true);
        if (tutor)
            UserAPI.delete_user(tutor.user_id)
                .then((data) => {
                    notify("Le tuteur a été supprimé avec succès");
                    setError("");
                    if (props.onClose) {
                        props.onClose();
                    }
                    // Navigate back to the previous page
                    navigate(-1);
                })
                .catch((error) => {
                    setError(error);
                    notify(error, "error");
                })
                .finally(() => {
                    setLoading(false);
                });
    };

    return (
        <div>
            <div className="px-4 py-3">
                {error && <Alert color="error">{error}</Alert>}

                <div className={`mt-6 `}>
                    <p className="text-gray-800">
                        Voulez-vous supprimer définitivement le profil de{" "}
                        <strong>
                            {tutor?.first_name} {tutor?.last_name}
                        </strong>{" "}
                        ?
                    </p>
                    <p className="text-sm text-red-600 mt-2 font-semibold">
                        ⚠️ Cette action est irréversible. Toutes les données associées à ce tuteur seront supprimées.
                    </p>
                </div>

                <div className="flex gap-3 mt-4">
                    <ButtonLoading
                        type="button"
                        loading={loading}
                        label="Supprimer définitivement"
                        className="bg-red-600 hover:bg-red-700"
                        onClick={handleDelete}
                    />
                    <button
                        type="button"
                        onClick={props.onClose}
                        className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    >
                        Annuler
                    </button>
                </div>
            </div>
        </div>
    );
}
